import { useMemo } from 'react';
import { useGoodsRoute } from '../../../hooks/useGoodsRoute';

export type EntryAdInfo = {
  list_id: string;
  campaign_id: string;
  parameters: string;
  goods_sno: number;
};

/**
 * - 메타피드(상품 카드) 클릭으로 PDP에 진입할 때 전달되는 광고 정보.
 * - native(iOS/Android)는 PDP에 진입할 때 받은 ad 정보를 보관해서, PDP 내부 액션(찜/찜해제 등)
 *   시점에 ad event(`bridge.logAdEvent`)를 추가로 발화함.
 * - JSON string으로 들어오므로 파싱 후 객체 반환. 광고가 아니면 null.
 */
export const useEntryAdInfo = (): EntryAdInfo | null => {
  const { params } = useGoodsRoute<'GoodsDetail'>();

  return useMemo(() => {
    const raw = params.extras?.ad;
    if (raw == null) return null;
    try {
      const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
      if (parsed == null || typeof parsed !== 'object') return null;
      return parsed as EntryAdInfo;
    } catch {
      return null;
    }
  }, [params.extras?.ad]);
};
